import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAlgoliaIndex } from "../../services/algolia";
import { api } from "../../store/config";
import { applyAlgoliaPending, applyAlgoliaRejection } from "./eventsSearch.mjs";

export const setAlgoliaToken = createAsyncThunk(
  "algolia/setAlgoliaToken",
  (_, { getState }) => {
    const { account } = getState();
    return account.currentUser.getIdToken();
  }
);

export const setAlgoliaKey = createAsyncThunk(
  "algolia/setAlgoliaKey",
  async(_) => {
    const {data} = await api.userAlgoliaToken();
    return data.data.key;
  }
);

export const setAlgoliaIndex = createAsyncThunk(
  "algolia/setAlgoliaIndex",
  ({index,sort}, { getState }) => {
    const { algolia } = getState();
    let mode =
      process.env.GATSBY_FIREBASE_CONFIG_PROJECT_ID.split("-").pop() ===
      "staging"
        ? "-staging"
        : "";
    return getAlgoliaIndex(`${index}${mode}${sort?'_'+sort:''}`, algolia.key);
  }
);

export const algoliaSlice = createSlice({
  name: "algolia",
  initialState: {
    loading: true,
    token: null,
    key: null,
    index: null,
    // Bootstrap failures used to be swallowed entirely, leaving consumers unable to tell
    // "still starting up" from "broken" — see issue #440.
    error: null
  },
  reducers: {
    setIndex: (state, action) => {
      state.index = action.payload;
    },
    clearAlgoliaError: (state) => {
      state.error = null;
    }
  },
  extraReducers: {
    [setAlgoliaToken.fulfilled]: (state, action) => {
      state.token = action.payload;
      return;
    },
    [setAlgoliaToken.pending]: applyAlgoliaPending,
    [setAlgoliaToken.rejected]: (state, action) =>
      applyAlgoliaRejection(state, action, "token", "token"),
    [setAlgoliaKey.fulfilled]: (state, action) => {
      state.key = action.payload;
      return;
    },
    [setAlgoliaKey.pending]: applyAlgoliaPending,
    [setAlgoliaKey.rejected]: (state, action) =>
      applyAlgoliaRejection(state, action, "key", "key"),
    [setAlgoliaIndex.fulfilled]: (state, action) => {
      state.index = action.payload;
      state.loading = false;
      state.error = null;
      return;
    },
    [setAlgoliaIndex.pending]: applyAlgoliaPending,
    [setAlgoliaIndex.rejected]: (state, action) =>
      applyAlgoliaRejection(state, action, "index", "index"),
  },
});
export const { setIndex, clearAlgoliaError } = algoliaSlice.actions;
export default algoliaSlice.reducer;